// extracted by mini-css-extract-plugin
export default {"mainWrapper":"OnBoardingLayout_mainWrapper__2rG8+"};